import React from "react";

export function GlobalStyles() {
  return (
    <style>{`
      @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,wght@0,500;0,600;1,500&family=Inter:wght@400;500;600&family=JetBrains+Mono:wght@400;500&display=swap');

      * { scroll-behavior: smooth; }

      button { transition: transform .15s ease; }
      button:active { transform: scale(0.94); }

      .nav-link { position: relative; padding-bottom: 4px; }
      .nav-link::after {
        content: ''; position: absolute; left: 0; bottom: 0; height: 1px; width: 0;
        background: #1E9AFF; transition: width .3s ease;
      }
      .nav-link:hover::after { width: 100%; }

      .btn-primary { background: #1E9AFF; color: #FFFFFF; transition: transform .3s ease, box-shadow .3s ease, background-color .3s ease; }
      .btn-primary:hover { background: #3FA9FF; transform: translateY(-2px); box-shadow: 0 14px 30px rgba(30,154,255,0.35); }
      .btn-primary:active { transform: scale(0.95); box-shadow: 0 6px 14px rgba(30,154,255,0.35); }

      .btn-outline { border: 1px solid rgba(255,255,255,0.18); color: #F3F1EC; transition: all .3s ease; }
      .btn-outline:hover { border-color: #1E9AFF; background: rgba(30,154,255,0.08); }

      .price-tag {
        position: relative;
        background: #1E2128;
        border: 1px solid rgba(255,255,255,0.1);
        clip-path: polygon(14% 0, 100% 0, 100% 100%, 14% 100%, 0 50%);
        padding-left: 20px;
      }
      .tag-hole {
        position: absolute; left: 7px; top: 50%; transform: translateY(-50%);
        width: 5px; height: 5px; border-radius: 50%; background: #F3F1EC; opacity: .35;
      }
      .tag-hole-lg { width: 16px; height: 16px; border: 2px solid rgba(255,255,255,0.25); border-radius: 50%; margin: 0 auto; }

      .checkout-input {
        background: rgba(255,255,255,0.03);
        border: 1px solid rgba(255,255,255,0.12);
        color: #F5F1EA;
        padding: 12px 16px;
        border-radius: 10px;
        font-size: 14px;
        outline: none;
        transition: border-color .2s ease, background-color .2s ease;
        width: 100%;
      }
      .checkout-input::placeholder { color: rgba(245,241,234,0.35); }
      .checkout-input:focus { border-color: #1E9AFF; background: rgba(30,154,255,0.05); }

      @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
      .spin { animation: spin 0.8s linear infinite; }

      @keyframes checkmarkPop {
        0% { transform: scale(0); opacity: 0; }
        60% { transform: scale(1.15); opacity: 1; }
        100% { transform: scale(1); opacity: 1; }
      }
      .checkmark-pop { animation: checkmarkPop 0.55s cubic-bezier(.34,1.56,.64,1); }

      @keyframes marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }
      .marquee-track { display: flex; width: max-content; animation: marquee 32s linear infinite; }
      .marquee-wrap:hover .marquee-track { animation-play-state: paused; }

      @keyframes float1 { 0%,100% { transform: translate(0,0) scale(1); } 50% { transform: translate(30px,-24px) scale(1.08); } }
      @keyframes float2 { 0%,100% { transform: translate(0,0) scale(1); } 50% { transform: translate(-25px,25px) scale(1.05); } }
      .blob1 { animation: float1 9s ease-in-out infinite; }
      .blob2 { animation: float2 11s ease-in-out infinite; }

      @keyframes floatTag { 0%,100% { transform: rotate(-6deg) translateY(0); } 50% { transform: rotate(-6deg) translateY(-14px); } }
      .float-tag { animation: floatTag 5s ease-in-out infinite; }

      @keyframes bounceY { 0%,100% { transform: translate(-50%,0); } 50% { transform: translate(-50%,8px); } }
      .scroll-cue { animation: bounceY 2s ease-in-out infinite; }

      @keyframes bump { 0% { transform: scale(1); } 30% { transform: scale(1.3); } 60% { transform: scale(0.95); } 100% { transform: scale(1); } }
      .cart-bump { animation: bump .4s ease; }

      @keyframes heartPop { 0% { transform: scale(1); } 40% { transform: scale(1.4); } 70% { transform: scale(0.85); } 100% { transform: scale(1); } }
      .heart-pop { animation: heartPop .45s cubic-bezier(.36,1.4,.64,1); }

      @keyframes fadeScaleIn { from { opacity: 0; transform: scale(0.92); } to { opacity: 1; transform: scale(1); } }
      .lightbox-content { animation: fadeScaleIn .3s cubic-bezier(.16,.84,.44,1); }
      .lightbox-overlay { animation: fadeIn .25s ease; }
      @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }

      @keyframes fadeInDown { from { opacity: 0; transform: translateY(-8px); } to { opacity: 1; transform: translateY(0); } }
      .mobile-menu { animation: fadeInDown .25s ease; }

      ::selection { background: #1E9AFF; color: #FFFFFF; }

      @media (prefers-reduced-motion: reduce) {
        .marquee-track, .blob1, .blob2, .float-tag, .scroll-cue, .cart-bump, .heart-pop { animation: none !important; }
      }
    `}</style>
  );
}

export default GlobalStyles;
